function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null,
/*#__PURE__*/
React.createElement("polygon", {
  id: "downtriangle-a",
  points: "0 0 6 0 6 4 0 4"
}));

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 2)"
},
/*#__PURE__*/
React.createElement("mask", {
  id: "downtriangle-b",
  fill: "#fff"
},
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#downtriangle-a"
})),
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M1.0039,-2e-05 L4.9949,-2e-05 C5.8339,-2e-05 6.3029,0.96898 5.7809,1.62598 L3.6509,3.75998 C3.2759,4.07998 2.7239,4.07998 2.3489,3.75998 L0.2189,1.62498 C-0.3021,0.96798 0.1659,-2e-05 1.0039,-2e-05",
  mask: "url(#downtriangle-b)"
}));

var SvgDownTriangle = function SvgDownTriangle(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 7,
      height: 7,
      viewBox: "0 0 7 7"
    }, props), _ref, _ref2)
  );
};

export default SvgDownTriangle;